import React from 'react';
import { useLocation, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { PERMISSION_TYPE } from '../../utils/constants';

import ProtectedRoute from '../../components/PrivateRoute';

import PortfolioDashboardV2 from "../PortfolioDashboardV2";
import DocumentCenter from '../DocumentCenter';
import FactSheetsPage from '../FactSheetsPage';
import {OtherAssetsCustomerView} from '../OtherAssets';
import CustomerThemeProvider from '../../components/CustomerThemeProvider';
import { CustomersDataProvider } from '../../components/CustomersDataProvider';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Documents from '../Documents';
import { getMenuItems, ROUTES } from '../../routes';
// import SharedSettingsProvider from '../../components/SharedSettingsProvider'; FIXME

import VirtualPortfolioManager from '../VirtualPortfolioManager';
import { addRoutes } from '../InvestmentPlatform/actions';
import {UserUtils} from '../../utils/utils';
import {getFromStorage, HIDE_CUSTOMER_HEADER_KEY, STORAGE_TYPE} from "../../utils/storage";

const mapStateToProps = (state) => ({
  auth: state.get('auth').toJS(),
  investmentPlatform: state.get('investmentPlatform').toJS(),
});

function hideHeader () {
  return getFromStorage(HIDE_CUSTOMER_HEADER_KEY, STORAGE_TYPE.SESSION)
}

const InvestingPlatform = (props) => {
  const [showMenuItems, setShowMenuItems] = React.useState(true);
  const location = useLocation();

  React.useEffect(() => {
    fetchMenuConfiguration();
  }, []);

  const fetchMenuConfiguration = async () => {
    const userIsBroker = UserUtils.isBroker(props.auth);
    const menuItems = [];

    if (userIsBroker) {
      menuItems.push('MODELPORTFOLIO_OVERVIEW', 'PRODUCTS_COMPARISON_NEW', 'PRODUCTS_COMPARISON');
    }
    const response = await getMenuItems(props.auth, menuItems);
    props.dispatch(addRoutes(response));
  };

  React.useEffect(() => {
    setShowMenuItems(() => {return !(location.pathname.indexOf('/factsheets/') >= 0)})
  }, [location]);

  return (
    <>
      {/*<SharedSettingsProvider>*/}
        <CustomersDataProvider>
          <CustomerThemeProvider loadTheme={true}>
            {!hideHeader() && (
              <Header showMenuItems={showMenuItems} />
            )}
            <div className={'app-main'} id={'app-main'}>
              <div className={'app-content'}>
                <Switch>
                  <ProtectedRoute authenticationType={PERMISSION_TYPE.BROKER_ONLY} path={ROUTES.BROKER.FORM_CENTER.path} component={DocumentCenter} beta/>
                  <ProtectedRoute authenticationType={PERMISSION_TYPE.CUSTOMER_ONLY} path={ROUTES.CUSTOMER.OTHER_ASSETS.path} component={OtherAssetsCustomerView} />
                  {/* Note: use diff "key" for same component to re-mount */}
                  <ProtectedRoute authenticationType={PERMISSION_TYPE.CUSTOMER_ONLY} path={ROUTES.CUSTOMER.DASHBOARD.path} isCurrentCustomerData={true} isVirtual={false} component={PortfolioDashboardV2} key={'real'} />
                  <ProtectedRoute authenticationType={PERMISSION_TYPE.CUSTOMER_ONLY} path={ROUTES.CUSTOMER.DASHBOARD_VIRTUAL.path} isCurrentCustomerData={true} isVirtual={true} component={PortfolioDashboardV2} key={'virtual'} />

                  <ProtectedRoute authenticationType={PERMISSION_TYPE.AUTHORIZED_ONLY} path={ROUTES.CUSTOMER.FACTSHEETS_DASHBOARD.path} component={FactSheetsPage} />
                  <ProtectedRoute authenticationType={PERMISSION_TYPE.CUSTOMER_ONLY} path={ROUTES.CUSTOMER.VIRTUAL_PORTFOLIO_MANAGER.path} component={VirtualPortfolioManager} />
                  <ProtectedRoute authenticationType={PERMISSION_TYPE.CUSTOMER_ONLY} path={ROUTES.CUSTOMER.DOCUMENTS.path} component={Documents} />
                  <ProtectedRoute authenticationType={PERMISSION_TYPE.AUTHORIZED_ONLY} path="" component={() => null} />
                </Switch>
              </div>
              <Footer />
            </div>
          </CustomerThemeProvider>
        </CustomersDataProvider>
      {/*</SharedSettingsProvider>*/}
    </>
  )
};

export default connect(mapStateToProps)(InvestingPlatform);